import type { ReactNode } from "react";
import { Link } from "react-router-dom";

/**
 * Sayfa yolu + başlık + sağdaki eylem düğmeleri.
 *
 * NİÇİN AYRI: `Layout` uygulama KABUĞUDUR (menü + üst çubuk + `<Outlet/>`) ve
 * react-router tarafından tek yerde kullanılır — sayfalar onu tekrar saramaz.
 * Sayfa içi başlık ihtiyacı bu bileşenle karşılanır.
 */
export function PageHeader({
  title,
  description,
  breadcrumb,
  actions,
  children,
}: {
  title: string;
  description?: ReactNode;
  /** Sayfa yolu. `to` verilirse bağlantı olur, verilmezse düz metin. */
  breadcrumb?: Array<{ label: string; to?: string }>;
  /** Sağ üstteki düğmeler. */
  actions?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <>
      <div className="mb-6 animate-fade-in">
        {breadcrumb && breadcrumb.length > 0 ? (
          <nav aria-label="Sayfa yolu" className="mb-1.5 text-xs font-medium">
            <ol className="flex flex-wrap items-center gap-2 text-gray-500">
              {breadcrumb.map((b, i) => (
                <li key={`${b.label}-${i}`} className="flex items-center gap-2">
                  {i > 0 ? <span aria-hidden="true">/</span> : null}
                  {b.to ? (
                    <Link to={b.to} className="hover:text-gray-700 hover:underline">
                      {b.label}
                    </Link>
                  ) : (
                    <span className="text-gray-700">{b.label}</span>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        ) : null}

        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0">
            <h1 className="truncate text-2xl font-bold tracking-tight text-gray-950 sm:text-[28px] sm:leading-9">
              {title}
            </h1>
            {description ? (
              <div className="mt-1.5 max-w-3xl text-sm leading-relaxed text-gray-500">{description}</div>
            ) : null}
          </div>
          {actions ? (
            <div className="flex shrink-0 flex-wrap gap-2">{actions}</div>
          ) : null}
        </div>
      </div>
      {children}
    </>
  );
}

export default PageHeader;
